import { CSS_CLASSES, SELECTORS } from "../constants/CSSClasses"

export class DomHelper {
  public static setBindingValue(
    target: any,
    bindingPath: string,
    value: any,
  ): void {
    let pathParts = bindingPath.split('.')
    let current = target
    let multipleTargets : any[] = [];
    let nodeList : any;
    let valueType = ''

    if(pathParts.length === 1){
      target[bindingPath] = value;
      return
    }
    
    // check for target
    if(pathParts.length>1 && pathParts[0].startsWith('$')){
      current = (target as HTMLElement).querySelector(pathParts[0].replace('$','.'));
      nodeList = (target as HTMLElement).querySelectorAll(pathParts[0].replace('$','.'));
      pathParts.splice(0,1);
    }

    if(pathParts[pathParts.length-1] === 'transform'){
      // need to return value in degrees
      valueType = 'deg'
    }
    // Traverse the path to the second-to-last key
    for (let i = 0; i < pathParts.length - 1 && current; i++) {
      const key = pathParts[i]

      // If the key doesn't exist, log an error
      if (!(key in current)) {
        console.error(`Invalid binding path: ${bindingPath}`)
        return
      }

      current = current[key]
      if(i ==0 && nodeList){
        for(var mi = 0; mi<nodeList.length;mi++){
          multipleTargets.push(nodeList[mi][key]);
        }
      }
      else if(i>0 && nodeList){
        for (var mi = 0; mi < multipleTargets.length; mi++) {
          const target = multipleTargets[mi];
          if (target && typeof target === 'object') {
            multipleTargets[mi] = (target as any)[key];
          } 
        }
      }
    }

    // Set the value at the final key
    const finalKey = pathParts[pathParts.length - 1]
    if(!value){
      current[finalKey] = ''
      return;
    }

    if (current) {
      if(valueType === 'deg' && value.toString()?.endsWith('px')){
        value = value.replace('px','')
        value = 'rotate('+value+'deg)'
      }
      current[finalKey] = value
      if(multipleTargets){
        for(var mi = 0; mi<multipleTargets.length;mi++){
          multipleTargets[mi][finalKey] = value          
        }
      }
      if(finalKey === "padding"){
        const paddingValue = value.replace('px','')
        current["height"] = `calc(100% - ${Number(paddingValue) * 2}px)`
        current["width"] = `calc(100% - ${Number(paddingValue) * 2}px)`
      }
      else if (finalKey === "gap") {
        const gapValue = Number(value.replace('px', ''));
      
        const chkBoxContainers = target.querySelectorAll('.option-container') as HTMLInputElement[];
        const txtBoxContainers = target.querySelectorAll('.textbox-input-container') as HTMLInputElement[];
        const txtBoxes = target.querySelectorAll('.textbox-input-container input[type="text"]') as HTMLInputElement[];
        chkBoxContainers.forEach(container => {
          const input = container.style.width;
          container.style.width = input.replace(/(\d+)px/, `${(gapValue+2)}px`);
        });
        txtBoxContainers.forEach(container => {
          const input = container.style.width;
          container.style.width = input.replace(/(\d+)px/, `${(gapValue+2)}px`);
        });
        txtBoxes.forEach(txtBox => {
          const input = txtBox.style.width;
          txtBox.style.width = input.replace(/(\d+)px/, `${(gapValue+2)}px`);
        });
      }
      else if(finalKey === "fontSize"){
        const chkBoxes = target.querySelectorAll('.option-container input[type="checkbox"]') as HTMLInputElement[];
        const txtBoxes = target.querySelectorAll('.textbox-input-container input[type="text"]') as HTMLInputElement[];
        const label = target.querySelector('.option-container label') as HTMLInputElement;
        let lblHgtWithSL = 0;
        if(label){
          const prevText = label.innerHTML;
          label.innerHTML = "test";
          const computedStyle = window.getComputedStyle(label);
          lblHgtWithSL = parseFloat(computedStyle.height); 
          label.innerHTML = prevText;
        }

        if (chkBoxes.length > 0) {


          
          const computedStyle = window.getComputedStyle(target);
          const fontSize = parseFloat(computedStyle.fontSize); 
          chkBoxes.forEach((chkBox) => {
            let chkSize:number = 13;
            let scale = (fontSize * 1.0)/12;
            let newChkSize = chkSize * scale;
            (chkBox as HTMLInputElement).style.marginTop = `${(lblHgtWithSL-newChkSize)/2 + (newChkSize - chkSize)/2}px`;
            (chkBox as HTMLInputElement).style.transform = `scale(${scale})`;            
            (chkBox as HTMLInputElement).style.marginLeft = `${(newChkSize - chkSize)/2}px`;
            (chkBox as HTMLInputElement).style.marginRight = `${(newChkSize - chkSize)/2}px`;
          });
        }
        if (txtBoxes.length > 0) {
          const computedStyle = window.getComputedStyle(target);
          const fontSize = parseFloat(computedStyle.fontSize); 
          txtBoxes.forEach((txtBox) => {
            (txtBox as HTMLInputElement).style.fontSize = computedStyle.fontSize;
          });
        }
      }
    } else {
      console.error(`Cannot set value, target is null at path: ${bindingPath}`)
    }
  }

  /**
   * Dynamically retrieves a value from an object using a binding path.
   * @param target - The object to retrieve the value from.
   * @param bindingPath - The binding path (e.g., "style.backgroundColor").
   * @returns The value at the specified binding path, or undefined if the path is invalid.
   */
  public static getBindingValue(target: any, bindingPath: string): any {4
    // find the section 
    target = target.querySelector('.section')
    const pathParts = bindingPath.split('.')
    let current = target
    let valueType = ''

    if(pathParts.length === 1){
      return target[bindingPath]
    }
    if(pathParts[pathParts.length-1] === 'transform'){
      // need to return value in degrees
      valueType = 'deg'
    }
    
    for (const key of pathParts) {
      if (current && key in current) {
        current = current[key]
      } else {
        console.error(`Invalid binding path: ${bindingPath}`)
        return undefined
      }
    }
    if(!current){
      return ''
    }
    if(typeof current ==='string' && current.startsWith('rgb')){
        return this.rgbToHex(current)
    }
    if(valueType === 'deg'){
      return current ? current.replace('rotate(','').replace('deg)','') : ''
    }
    return current ? current : ''
  }
  static rgbToHex(rgb: string): string {
    const rgbValues = rgb.match(/\d+/g)?.map(Number);

    if (!rgbValues || rgbValues.length !== 3) {
      throw new Error("Invalid RGB format");
    }

    const hex = rgbValues
      .map(value => {
        let hexValue = value.toString(16);
        return hexValue.length === 1 ? "0" + hexValue : hexValue;
      })
      .join('');

    return `#${hex}`;
  }

  public static getId = function ({ length = 6, existing = [] }: { length?: number, existing?: string[] }) {
    const randomId = function (length = 6) {
      return Math.random().toString(36).substring(2, length + 2);
    };
    
    const checkId = function (id: any, existing: string[] = []) {
      let match = existing.find(function (item) {
        return item === id;
      });
      return match ? false : true;
    };

    const limit = 100;
    let attempts = 0;
    let id = '';
    while (!id && attempts < limit) {
      id = randomId(length);
      if (!checkId(id, existing)) {
        id = '';
        attempts++;
      }
    }
    return id;
  };

  public static getSectionDiv(sectionId:string):HTMLElement{
    const el = document.querySelector('div.layout-drag-item#' + CSS.escape(sectionId)) as HTMLElement;
    if(!el){
      throw new Error("section element now found with provided ID "+sectionId)
    }

    return el;
  }

  public static cloneObj(obj:any ){
    return JSON.parse(JSON.stringify(obj));
  }

  public static getAllEl(selector:string){
    return document.querySelectorAll(selector);
  }
  public static getEl(selector:string){
    return document.querySelector(selector);
  }

  public static getAllDragItems(){
    return document.querySelectorAll("."+CSS_CLASSES.LAYOUT_DRAG_ITEM);
  }

  public static focusViewport(){
    (document.querySelector(SELECTORS.VIEWPORT_CONTAINER) as HTMLDivElement).focus()
  }


}